import { getOrFetchProductVariants } from "./offline-sync/reference-cache";

type CachedVariantMatch = {
  id: string;
  name: string;
  price: number | null;
  optionValueIds?: string[];
};

function sameOptionValueSet(
  left: string[],
  right: string[],
): boolean {
  if (left.length !== right.length) return false;
  const sortedLeft = [...left].sort();
  const sortedRight = [...right].sort();
  return sortedLeft.every((value, index) => value === sortedRight[index]);
}

export async function findVariantByOptionsFromCache(
  branchId: string,
  productId: string,
  optionValueIds: string[],
): Promise<CachedVariantMatch | null> {
  const variants = await getOrFetchProductVariants<CachedVariantMatch>(
    branchId,
    productId,
  );

  if (optionValueIds.length === 0) {
    return variants[0] ?? null;
  }

  return (
    variants.find((variant) =>
      sameOptionValueSet(variant.optionValueIds ?? [], optionValueIds),
    ) ?? null
  );
}
